function isPageNotScrollable() {
  const documentHeight = document.documentElement.scrollHeight;
  const viewportHeight = window.innerHeight;
  return documentHeight <= viewportHeight;
}

function updateHeaderStickyForScrollState() {
  const header = document.querySelector('#shopify-section-header');
  if (!header) { return; }

  if (isPageNotScrollable()) {
    header.classList.remove('nav-sticky-bar');
  }
}

// expose globally for reuse after AJAX updates
window.updateHeaderStickyForScrollState = updateHeaderStickyForScrollState;
window.isPageNotScrollable = isPageNotScrollable;

function bindViewportKeyboardAdjust(options) {
  if (!window.visualViewport) return null;

  const settings = Object.assign(
    {
      target: null,
      focusSelectors: '',
      closeSelectors: '',
      minHeight: 320,
      heightOffset: 8,
      resetBottom: '0px',
      resetMaxHeight: '100vh',
      focusAnchor: '',      // selector inside target: block to bring to the top on focus (the form heading)
      footerSelector: ''    // selector inside target: sticky footer that overlays the scroll box bottom
    },
    options || {}
  );

  const targetEl =
    typeof settings.target === 'string'
      ? document.querySelector(settings.target)
      : settings.target;
  if (!targetEl) return null;

  const vv = window.visualViewport;
  const resetAdjust = () => {
    console.log('[KUSHALS-DEBUG] resetAdjust — target:', targetEl.className, 'resetBottom:', JSON.stringify(settings.resetBottom), 'resetMaxHeight:', JSON.stringify(settings.resetMaxHeight));
    targetEl.style.bottom = settings.resetBottom;
    targetEl.style.maxHeight = settings.resetMaxHeight;
  };

  // On focus, once the keyboard is up: scroll the sheet so the whole details block (heading → inputs → CONFIRM)
  // sits in the visible area when it fits, else put the focused input at the top (user 2026-10-22).
  let pendingReveal = null, revealTimer = 0;
  const revealFocusedField = (input) => {
    if (!input || !targetEl.contains(input)) return;
    if (targetEl.scrollHeight <= targetEl.clientHeight + 1) return;   // nothing to scroll (desktop / short content)
    const footer = settings.footerSelector ? targetEl.querySelector(settings.footerSelector) : null;
    const visible = targetEl.clientHeight - (footer ? footer.getBoundingClientRect().height : 0);
    const origin = targetEl.getBoundingClientRect().top - targetEl.scrollTop;
    const anchor = settings.focusAnchor ? targetEl.querySelector(settings.focusAnchor) : null;
    const inputTop = input.getBoundingClientRect().top - origin;
    const inputBottom = input.getBoundingClientRect().bottom - origin;
    const anchorTop = anchor ? anchor.getBoundingClientRect().top - origin : inputTop;
    const fits = inputBottom - anchorTop <= visible - 16;
    const next = Math.max(0, Math.min((fits ? anchorTop : inputTop) - 8, targetEl.scrollHeight - targetEl.clientHeight));
    console.log('[KUSHALS-DEBUG] revealFocusedField — input:', input.name || input.placeholder, 'visible:', visible, 'anchorTop:', Math.round(anchorTop), 'inputTop/Bottom:', Math.round(inputTop), Math.round(inputBottom), 'fits:', fits, 'scrollTop:', targetEl.scrollTop, '->', next);
    targetEl.scrollTop = next;
  };
  const scheduleReveal = () => {
    clearTimeout(revealTimer);
    revealTimer = setTimeout(() => {
      // No keyboard-height gate: Android Chrome shrinks the layout viewport, so keyboardHeight reads 0 there.
      // Gate on "input still focused" + "sheet actually overflows" instead; pendingReveal clears on blur.
      if (pendingReveal && document.activeElement === pendingReveal) revealFocusedField(pendingReveal);
    }, 150);
  };

  const applyAdjust = () => {
    // Layout viewport height: the larger of the two covers iOS builds where innerHeight shrinks with the keyboard.
    const layoutHeight = Math.max(window.innerHeight, document.documentElement.clientHeight);
    const keyboardHeight = layoutHeight - vv.height;   // vv.height only shrinks for the keyboard; panning doesn't change it
    const overlap = Math.max(0, layoutHeight - vv.height - vv.offsetTop);
    const rect = targetEl.getBoundingClientRect();
    const active = document.activeElement;
    // [KUSHALS-DEBUG] on-screen mirror for phone screen recordings: add ?kdebug=1 to the URL.
    if (/[?&]kdebug=1/.test(window.location.search)) {
      let hud = document.getElementById('kushals-debug-hud');
      if (!hud) {
        hud = document.createElement('pre');
        hud.id = 'kushals-debug-hud';
        hud.style.cssText = 'position:fixed;top:0;left:0;z-index:2147483647;margin:0;padding:4px 6px;background:rgba(0,0,0,.8);color:#0f0;font:11px/1.3 monospace;pointer-events:none;white-space:pre-wrap;max-width:100vw;';
        document.body.appendChild(hud);
      }
      hud.textContent = 'tgt ' + targetEl.className.split(' ')[0] + ' | innerH ' + window.innerHeight + ' docH ' + document.documentElement.clientHeight + ' | vvH ' + Math.round(vv.height) + ' vvTop ' + Math.round(vv.offsetTop) + ' pageTop ' + Math.round(vv.pageTop) + ' scrollY ' + Math.round(window.scrollY) + ' | kb ' + keyboardHeight + ' overlap ' + overlap + ' ' + (keyboardHeight < 40 ? 'RESET' : 'LIFT') + ' | sheet ' + Math.round(rect.top) + '/' + Math.round(rect.bottom) + ' h' + Math.round(rect.height) + ' | active ' + (active ? active.tagName + '[' + (active.name || active.placeholder || '') + ']' : '-') + ' | ' + new Date().toISOString().slice(11, 23);
    }
    console.log('[KUSHALS-DEBUG] applyAdjust — target:', targetEl.className, '| innerHeight:', window.innerHeight, 'docClientH:', document.documentElement.clientHeight, '| vv.height:', Math.round(vv.height), 'vv.offsetTop:', Math.round(vv.offsetTop), 'vv.pageTop:', Math.round(vv.pageTop), 'scrollY:', window.scrollY, '| keyboardHeight:', keyboardHeight, 'overlap:', overlap, 'branch:', keyboardHeight < 40 ? 'RESET' : 'LIFT', '| sheet top/bottom/height:', Math.round(rect.top), Math.round(rect.bottom), Math.round(rect.height), '| active:', active && (active.tagName + '.' + active.className + '[' + (active.name || active.placeholder || '') + ']'));
    // Keyboard closed (or a sub-40px browser-chrome wobble): drop the inline styles so the
    // sheet's own CSS (bottom:0, 92dvh cap) rules again (2026-10-16, reserve / appointment sheets).
    // Decided on keyboardHeight, not overlap (2026-10-22): iOS pans the visual viewport when a drag runs past the
    // sheet's end, so overlap hit 0 with the keyboard still up; the old reset grew the sheet back to 92dvh, killed
    // its scroll overflow and snapped scrollTop to 0 ("sheet jumps back up when fully scrolled"). During a pan only
    // `bottom` moves now, so the sheet tracks the visible area and keeps its scroll position.
    if (keyboardHeight < 40) { resetAdjust(); return; }
    targetEl.style.bottom = overlap + 'px';
    const nextMax = Math.max(settings.minHeight, vv.height - settings.heightOffset) + 'px';
    if (targetEl.style.maxHeight !== nextMax) targetEl.style.maxHeight = nextMax;
  };

  const onFocusAdjust = (e) => {
    console.log('[KUSHALS-DEBUG] onFocusAdjust — input:', e && e.target && (e.target.name || e.target.placeholder), 'value:', e && e.target && e.target.value, 'inline bottom/maxHeight before:', JSON.stringify(targetEl.style.bottom), JSON.stringify(targetEl.style.maxHeight));
    pendingReveal = e && e.target;
    requestAnimationFrame(applyAdjust);
    setTimeout(applyAdjust, 50);
    scheduleReveal();   // keyboard already up (tapping the next field): no resize comes, reveal from here
  };

  vv.addEventListener('resize', function () { console.log('[KUSHALS-DEBUG] vv resize event — target:', targetEl.className); applyAdjust(); if (pendingReveal) scheduleReveal(); });   // keyboard animation fires several resizes; the last one wins. Not on vv scroll: must not re-reveal while the user drags.
  vv.addEventListener('scroll', function () { console.log('[KUSHALS-DEBUG] vv scroll event — target:', targetEl.className); applyAdjust(); });

  const focusEls = settings.focusSelectors
    ? Array.from(document.querySelectorAll(settings.focusSelectors))
    : [];
  focusEls.forEach((el) => {
    el.addEventListener('focus', onFocusAdjust);
    el.addEventListener('blur', () => { if (pendingReveal === el) pendingReveal = null; });
  });

  const closeEls = settings.closeSelectors
    ? Array.from(document.querySelectorAll(settings.closeSelectors))
    : [];
  closeEls.forEach((el) => {
    el.addEventListener('click', resetAdjust);
  });

  console.log('[KUSHALS-DEBUG] bindViewportKeyboardAdjust — target:', targetEl.className, 'focusEls:', focusEls.length, 'closeEls:', closeEls.length, 'UA:', navigator.userAgent);
  applyAdjust();

  return {
    apply: applyAdjust,
    reset: resetAdjust
  };
}

window.KViewportKeyboardAdjust = window.KViewportKeyboardAdjust || {
  bind: bindViewportKeyboardAdjust
};

window.isAccountEditOtpLocked = window.isAccountEditOtpLocked || function () {
  return window.location.pathname === '/pages/account-edit' && document.body.dataset.customer !== 'true';
};

// Keep collection location pincode input numeric-only even when PLP script is not active.
document.addEventListener('input', function (event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (!target.classList.contains('store-select-pin-input') && !target.classList.contains('pdp-pincode-input')) return;

  const digitsOnly = target.value.replace(/\D/g, '').slice(0, 6);
  if (target.value !== digitsOnly) {
    target.value = digitsOnly;
  }
});

function normalizeStoredPin(value) {
  return String(value || '').replace(/\D/g, '').slice(0, 6);
}

function getExplicitStoredPin() {
  const raw = window.KushalsStorageTTL ? window.KushalsStorageTTL.get('pin') : localStorage.getItem('pin');
  return normalizeStoredPin(raw);
}

function getLocationStorePostalPin() {
  const raw = window.KushalsStorageTTL ? window.KushalsStorageTTL.get('location_store') : localStorage.getItem('location_store');
  if (!raw) return '';
  try {
    const parsed = JSON.parse(raw);
    return normalizeStoredPin(parsed && (parsed.postal || parsed.pinCode || parsed.pin));
  } catch (error) {
    return '';
  }
}

function getStoreInputPin() {
  return getExplicitStoredPin() || getLocationStorePostalPin();
}

function syncGlobalPincodeUI(preferredPin, forceInputUpdate) {
  const preferred = normalizeStoredPin(preferredPin);
  if (preferred.length === 6) {
    localStorage.setItem('pin', preferred);
    window.KushalsStorageTTL && window.KushalsStorageTTL.touch('pin');
  }

  const pin = preferred.length === 6 ? preferred : getExplicitStoredPin();
  if (!pin) return;

  document.querySelectorAll('.ct_pincode').forEach(function (el) {
    el.textContent = ', ' + pin;
  });

  document.querySelectorAll('.ct_pin_check').forEach(function (input) {
    if (!(input instanceof HTMLInputElement)) return;
    input.value = '';
  });

  document.querySelectorAll('.store-select-pin-input').forEach(function (input) {
    if (!(input instanceof HTMLInputElement)) return;
    const current = normalizeStoredPin(input.value);
    if (forceInputUpdate || !current) {
      input.value = pin;
    }
  });
}

window.syncGlobalPincodeUI = syncGlobalPincodeUI;

// PDP "Delivery & Stores" pincode widget (sections/main-product.liquid, block type Zipcoder).
// Reuses the global `pin` key + syncGlobalPincodeUI so header pincode stays in sync.
function initPdpPincodeChecker() {
  document.querySelectorAll('[data-pdp-pincode]').forEach(function (container) {
    if (container.dataset.pdpPincodeBound === 'true') return;
    container.dataset.pdpPincodeBound = 'true';

    const entryWrap = container.querySelector('.ct_zip_wrap--entry');
    const savedWrap = container.querySelector('.ct_zip_wrap--saved');
    const input = container.querySelector('.pdp-pincode-input');
    const checkBtn = container.querySelector('.pdp-pincode-check');
    const changeBtn = container.querySelector('.pdp-pincode-change');
    const valueEl = container.querySelector('.pdp-pincode-value');
    const errorEl = container.querySelector('.ct_not_valid_error_msg');
    if (!entryWrap || !savedWrap || !input || !checkBtn || !changeBtn || !valueEl) return;

    function showSaved(pin) {
      valueEl.textContent = pin;
      entryWrap.style.display = 'none';
      savedWrap.style.display = '';
    }

    function showEntry() {
      entryWrap.style.display = '';
      savedWrap.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';
      input.value = '';
      input.focus();
    }

    const existingPin = getStoreInputPin();
    if (existingPin) {
      showSaved(existingPin);
    }

    checkBtn.addEventListener('click', function () {
      const pin = normalizeStoredPin(input.value);
      if (pin.length !== 6) {
        if (errorEl) errorEl.style.display = '';
        return;
      }
      if (errorEl) errorEl.style.display = 'none';
      syncGlobalPincodeUI(pin, true);
      showSaved(pin);
    });

    changeBtn.addEventListener('click', showEntry);
  });
}

window.initPdpPincodeChecker = initPdpPincodeChecker;

// PDP mobile gallery overlay: "1 / N" counter, HIGHLIGHTS chip, wishlist heart moved onto the image.
function initPdpGalleryUi() {
  const main = document.querySelector('.template-product .ct_main_Product_img');
  if (!main || main.dataset.pdpGalleryUiBound === 'true') return;
  main.dataset.pdpGalleryUiBound = 'true';

  const cur = main.querySelector('.pdp-gallery-counter__cur');
  const total = main.querySelector('.pdp-gallery-counter__total');
  const slideshow = main.querySelector('.product-slideshow');

  // .main-image is taller than the visible slide (dots / spacing below), so anchor overlays to the slide bottom.
  const place = function () {
    if (!slideshow) return;
    const gap = main.clientHeight - (slideshow.offsetTop + slideshow.offsetHeight);
    main.style.setProperty('--pdp-gallery-bottom', Math.max(0, gap) + 14 + 'px');
  };
  place();
  window.addEventListener('resize', place);
  window.addEventListener('load', place);

  if (cur && slideshow && window.jQuery && jQuery.fn.slick) {
    const $s = jQuery(slideshow);
    const update = function (slick) {
      const s = slick || ($s.hasClass('slick-initialized') ? $s.slick('getSlick') : null);
      if (!s) return;
      cur.textContent = s.currentSlide + 1;
      if (total) total.textContent = s.slideCount;
      requestAnimationFrame(place);
    };
    $s.on('init reInit afterChange setPosition', function (event, slick) {
      update(slick);
    });
    update();
  }

  const chip = main.querySelector('.pdp-highlights__chip');
  const panel = main.querySelector('.pdp-highlights__panel');
  if (chip && panel) {
    chip.addEventListener('click', function (event) {
      event.preventDefault();
      const open = panel.classList.toggle('is-open');
      chip.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (event) {
      if (!panel.classList.contains('is-open')) return;
      if (event.target.closest('.pdp-highlights')) return;
      panel.classList.remove('is-open');
      chip.setAttribute('aria-expanded', 'false');
    });
  }

}

window.initPdpGalleryUi = initPdpGalleryUi;

function ensureLocationPopupScrollLock() {
  const popup = document.querySelector('.ct_location_popup');
  if (!popup) return;
  const isVisible = window.getComputedStyle(popup).display !== 'none';
  if (isVisible && !window.__ctLocationPopupScrollLocked) {
    window.themeScrollLock && window.themeScrollLock.lock();
    window.__ctLocationPopupScrollLocked = true;
  } else if (!isVisible && window.__ctLocationPopupScrollLocked) {
    window.themeScrollLock && window.themeScrollLock.unlock();
    window.__ctLocationPopupScrollLocked = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  syncGlobalPincodeUI();
  initPdpPincodeChecker();
  initPdpGalleryUi();
  updateHeaderStickyForScrollState();
  ensureLocationPopupScrollLock();

  const popup = document.querySelector('.ct_location_popup');
  if (popup && !window.__locationPopupLockObserver) {
    const observer = new MutationObserver(() => {
      ensureLocationPopupScrollLock();
    });
    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    window.__locationPopupLockObserver = observer;
  }
  if (window.KViewportKeyboardAdjust && typeof window.KViewportKeyboardAdjust.bind === 'function') {
    window.KViewportKeyboardAdjust.bind({
      target: '.ct_location_popup .popup-content',
      focusSelectors: '.ct_location_popup .ct_pin_check, .ct_location_popup .store-select-pin-input',
      closeSelectors: '.ct_location_popup .location-popup-close, .ct_location_popup .popup-bg'
    });
  }

  document.addEventListener('focusin', function (event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('.store-select-pin-input')) return;
    if (target.getAttribute('data-skip-autofill') === 'true') return;
    const pin = getStoreInputPin();
    if (pin && !normalizeStoredPin(target.value)) {
      target.value = pin;
    }
  });
});

window.addEventListener('DOMContentLoaded', () => {
  // code from theme.liquid
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (settings.url === "https://zip.appjetty.com//appjetty-zipcode") {
      const estimateDay = $.parseJSON(xhr.responseText);
      const todayDate = new Date();
      let deliveryDate = new Date();
      deliveryDate.setDate(todayDate.getDate() + parseInt(estimateDay.estimated_day));
      date = deliveryDate.toString().split(" ");
      $('.estimation_msg .estimated_days').html("Order Now & Get it by " + date[0] + ", " + date[1] + " " + date[2]);
      $('.success_msg').html("<span>Free Shipping in India for orders above Rs 499</span>" + "<span>Easy 15 days return available</span>");
    }
    if (settings.url.includes("/apps/ssw/lite2/fave?")) {
      $('.ssw-link-fave-menu').trigger('click');
    }
  });

  // code from theme.liquid
  $('.mobile-navigation-drawer .navigation__tier-2 .navigation__children-toggle').trigger('click');

  // code from footer.liquid
  var width = $(window).width();
    if (width <= 480) {
      setTimeout(function() {
        $("#pagefooter .accordion .heading-1").trigger('click');
      },100);
    }
    $(".accordion_head").click(function () {
      if ($('.accordion_body').is(':visible')) {
        $(".accordion_body").slideUp(300);
        $(".plusminus").html('<img src="//cdn.shopify.com/s/files/1/0796/1959/files/Add_Plus.png?v=1651733780" width="24" height="24" >');
      }
      if ($(this).next(".accordion_body").is(':visible')) {
        $(this).next(".accordion_body").slideUp(300);
        $(this).children(".plusminus").html('<img src="//cdn.shopify.com/s/files/1/0796/1959/files/Add_Plus.png?v=1651733780" width="24" height="24" >');
      } else {
        $(this).next(".accordion_body").slideDown(300);
        $(this).children(".plusminus").html('<img loading="lazy" src="https://cdn.shopify.com/s/files/1/0796/1959/files/Add_Minus.png?v=1651733780" width="24" height="24" >');
      }
    });

  // code from theme.liquid
  function initFreshChat() {
    window.fcWidget.init({
      	 token: "9ae8f970-1669-4e10-b1d3-ffcda9112212",
	 host: "https://kushalsretailprivatelimited-org.freshchat.com"
    });
  }
  function initialize(i,t){var e;i.getElementById(t)?
  initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,
  e.src="https://kushalsretailprivatelimited-org.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}
  function initiateCall(){initialize(document,"Freshchat-js-sdk")}
  window.addEventListener?window.addEventListener("load",initiateCall,!1):
  window.attachEvent("load",initiateCall,!1);

  // scroll down for pdp
  $("#view_similar").click(function() {
      $('html,body').animate({                                                         
          scrollTop: $(".section-product-recommendations").offset().top-50},
          900);
  });

    function isVisibleSortButton(node) {
      if (!node) return false;
      return !!(node.offsetWidth || node.offsetHeight || (node.getClientRects && node.getClientRects().length));
    }

    function isSortDropdownActuallyOpen(node) {
      if (!node || String(node.getAttribute('aria-expanded')) !== 'true') return false;
      if (!isVisibleSortButton(node)) return false;
      var options = node.nextElementSibling;
      if (!options || !options.classList || !options.classList.contains('link-dropdown__options')) return true;
      var computed = window.getComputedStyle ? window.getComputedStyle(options) : null;
      if (!computed) return true;
      return computed.display !== 'none' && computed.visibility !== 'hidden';
    }

    function syncCollectionSortShadeState() {
      var $expandedButtons = jQuery('.template-collection .link-dropdown__button[aria-expanded="true"]');
      var hasOpenSort = false;

      $expandedButtons.each(function () {
        if (isSortDropdownActuallyOpen(this)) {
          hasOpenSort = true;
          return false;
        }
      });

      if (!hasOpenSort && $expandedButtons.length) {
        $expandedButtons.attr('aria-expanded', 'false').css('width', '');
      }

      jQuery('.template-collection .ct_fil_shade').toggleClass('ct_fill_active', hasOpenSort);
      jQuery('#shopify-section-header').toggleClass('ct_active_sort', hasOpenSort);
      jQuery('.template-collection').toggleClass('ct_active_sort_body', hasOpenSort);
    }

    function closeCollectionSortShade() {
      jQuery('.template-collection .link-dropdown__button[aria-expanded="true"]').attr('aria-expanded', 'false').css('width', '');
      syncCollectionSortShadeState();
    }

    window.syncCollectionSortShadeState = syncCollectionSortShadeState;
    window.closeCollectionSortShade = closeCollectionSortShade;

    jQuery(document).off('click.ctSortShadeToggle', '.CT_link-dropdown__button, .link-dropdown__button');
    jQuery(document).on('click.ctSortShadeToggle', '.CT_link-dropdown__button, .link-dropdown__button', function () {
      setTimeout(syncCollectionSortShadeState, 0);
    });

    jQuery(document).off('click.ctSortShadeDismiss', '.template-collection .ct_fil_shade');
    jQuery(document).on('click.ctSortShadeDismiss', '.template-collection .ct_fil_shade', function (e) {
      e.preventDefault();
      closeCollectionSortShade();
    });

    jQuery(document).off('click.ctSortShadeOption', '.template-collection .CT_link-dropdown__options a, .template-collection .link-dropdown__options a');
    jQuery(document).on('click.ctSortShadeOption', '.template-collection .CT_link-dropdown__options a, .template-collection .link-dropdown__options a', function () {
      setTimeout(closeCollectionSortShade, 0);
    });

    jQuery(document).off('keyup.ctSortShadeEsc');
    jQuery(document).on('keyup.ctSortShadeEsc', function (e) {
      if (e.key === 'Escape') closeCollectionSortShade();
    });

    syncCollectionSortShadeState();
  // Disabled DOB on account page
  var dtToday = new Date();
    
    var month = dtToday.getMonth() + 1;
    var day = dtToday.getDate();
    var year = dtToday.getFullYear();
    if(month < 10)
        month = '0' + month.toString();
    if(day < 10)
        day = '0' + day.toString();
    
    var maxDate = year + '-' + month + '-' + day;
    $('#birthday').attr('max', maxDate);

     document.addEventListener('theme:cartchanged', async (e) => {
    try {
      const response = await fetch('/cart.js'); // Adjust endpoint if needed
      const cart = await response.json();
      const itemCount = cart.item_count;
  
      if (itemCount == 1) {
        $('.majortitle [data-cart-count]').html(`(${itemCount} Item)`);
      } else {
        $('.majortitle [data-cart-count]').html(`(${itemCount} Items)`);
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  });

    let freshDeskChatBtn = document.querySelector('.fresh-desk-cart-init');
    if (freshDeskChatBtn) {
      freshDeskChatBtn.addEventListener('click', () => {
        fcWidget.open();
      })
    }
});

// $(document).ready(function () {
//   const result_url = window.AF_SMART_SCRIPT_RESULT?.clickURL || null;

//   if (result_url) {
//     setTimeout(() => {
//       window.AF_SMART_SCRIPT.fireImpressionsLink();
//     }, 1000);
//   }

//   // Call the function with either `result_url` or defaults
//   setHrefForElements(result_url);

//   function setHrefForElements(url) {
//     const defaultAndroidLink = 'https://play.google.com/store/apps/details?id=co.kushals';
//     const defaultIosLink = 'https://apps.apple.com/in/app/kushals-fashion-jewellery/id6450987987';
//     const isAndroid = navigator.userAgent.match(/Android|Opera Mini|IEMobile/i);
//     const isMobile = $(window).width() < 760;
//     const targetUrl = url || (isAndroid ? defaultAndroidLink : defaultIosLink);

//     // Apply mobile-specific logic
//     if (isMobile) {
//       if (isAndroid) {
//         jQuery('.bottom_pop_inner').addClass('ct_Andriod_link');
//       } else {
//         jQuery('.bottom_pop_inner').addClass('ct_IOS_link');
//       }

//       // Update href for relevant elements
//       jQuery('.bottom_pop_inner, .app-download-banner-inner a').prop('href', targetUrl);
//     } else {
//       console.warn("Not a mobile device; skipping mobile-specific logic.");
//     }
//   }
// });


window.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 768) {
    let header = document.querySelector('#shopify-section-header');
    let storeLocatorWrapper = document.querySelectorAll('.store-locator--wrapper');
    storeLocatorWrapper.forEach(locator => {
      let trigger = locator.querySelector('.store-locator--header'),
          target = locator.querySelector('.store-locator--content'),
          popCloseBtn = locator.querySelector('.store-locator--back');
  
          target.style.top = `${header.clientHeight}px`;
          target.style.height = `calc(100dvh - ${header.clientHeight}px)`;
  
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.classList.add('active');
            target.classList.add('active');
            window.scrollTo({left:0,top: (window.scrollY - 1)})
  
          })
  
          popCloseBtn.addEventListener('click', () => {
            target.classList.remove('active');
            trigger.closest('.store-locator--content').classList.remove('active');
          })
    });
  }
})

document.addEventListener("DOMContentLoaded", function () {
  
  const resultUrl = window.AF_SMART_SCRIPT_RESULT?.clickURL || null;

  if (resultUrl) {
    setTimeout(() => {
      if (window.AF_SMART_SCRIPT?.fireImpressionsLink) {
        window.AF_SMART_SCRIPT.fireImpressionsLink();
      }
    }, 1000);
  }

  // Call the function with either `resultUrl` or defaults
  setHrefForElements(resultUrl);
});
  function setHrefForElements(url) {
    const bottomPopElements = document.querySelectorAll('.bottom_pop_inner');
    const appDownloadLinks = document.querySelectorAll('.app-download-banner-inner a');
    const defaultAndroidLink = 'https://play.google.com/store/apps/details?id=co.kushals';
    const defaultIosLink = 'https://apps.apple.com/in/app/kushals-fashion-jewellery/id6450987987';
    const isAndroid = /Android|Opera Mini|IEMobile/i.test(navigator.userAgent);
    const isMobile = window.innerWidth < 760;
    const targetUrl = url || (isAndroid ? defaultAndroidLink : defaultIosLink);

    if (isMobile) {
    if (bottomPopElements.length > 0) {
      bottomPopElements.forEach(element => {
          if(isAndroid){
          element.classList.add('ct_Andriod_link');
          } else{
          element.classList.add('ct_IOS_link');
        }
        element.setAttribute('href', targetUrl);
      });
    }

    if (appDownloadLinks.length > 0) {
        appDownloadLinks.forEach(link => link.setAttribute('href', targetUrl));
      }
    }
  }

// FC WIDGET CODE
document.addEventListener('DOMContentLoaded', () => {
  if(__st.p == "product")
  {
    let fcWidgetScroll = false;
  
    const observer = new MutationObserver((mutationsList, observer) => {
      const freshChatBtn = document.querySelector('#fc_widget');
      if (freshChatBtn) {
        observer.disconnect(); // Stop observing after widget is found
  
        // Set initial state
        freshChatBtn.style.display = 'none';
  
        // Add scroll listener
        window.addEventListener('scroll', () => {
          if (window.scrollY > 200 && !fcWidgetScroll) {
            fcWidgetScroll = true;
            freshChatBtn.style.display = 'block';
          }
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  setTimeout(() => {
    let wsProducts = document.querySelectorAll('.no-ws-page .rb_wishlist_product_details_img');

    wsProducts.forEach((e) => {
      let handle = e.getAttribute('data-handle');
      e.addEventListener('click', () => {
        window.location.href = `/products/${handle}`;
      });
    });
  }, 1000);
});

const uniqueId = getCookie("browserUniqueId") || generateUniqueId();
setCookie("browserUniqueId", uniqueId, 365);
 
function setCookie(name, value, days) {
	const date = new Date();
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}
function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	return parts.length === 2 ? parts.pop().split(";").shift() : null;
}

function generateUniqueId() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0,
			v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

// Product card image slider (supports legacy + new Figma card markup)
(function () {
  const CAROUSEL_CONTEXT_SELECTOR = [
    '.slick-slider',
    '.swiper',
    '.swiper-container',
    '.flickity-enabled',
    '.owl-carousel',
    '.collection-slider',
    '.product-recommendations',
    '.ct-recently-viewed',
    '.recently-viewed',
    '.ct_recent',
    '.similar_pro_popup',
    '.shop-the-look',
    '.ct_custom_slider',
    '[data-carousel]',
    '[data-slider]'
  ].join(',');
  const SWIPE_THRESHOLD = 24;
  const swipeState = new WeakMap();
  let delegatedBound = false;
  let activeMouseSlider = null;

  function toNum(v, fallback) {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  }

  function isNewCardSlider(slider) {
    return !!(slider && slider.querySelector && slider.querySelector('.card-slider-track .product-img'));
  }

  function getSlides(slider) {
    if (isNewCardSlider(slider)) {
      return Array.from(slider.querySelectorAll('.card-slider-track .product-img'));
    }
    return Array.from(slider.querySelectorAll('.product-block__image[data-slide-index]'));
  }

  function getDots(slider) {
    if (isNewCardSlider(slider)) {
      return Array.from(slider.querySelectorAll('.card-carousel-dots .dot[data-slide], .card-carousel-dots span.dot'));
    }
    return Array.from(slider.querySelectorAll('.product-block__image-dot[data-slide-dot-index]'));
  }

  function revealImage(slide) {
    if (!slide) return;
    const img = slide.tagName === 'IMG' ? slide : slide.querySelector('img');
    if (!img) return;
    const dataSrc = String(
      img.getAttribute('data-slide-src') ||
      img.getAttribute('data-src') ||
      img.getAttribute('data-k-src') ||
      ''
    ).trim();
    const dataSrcset = String(img.getAttribute('data-srcset') || img.getAttribute('data-k-srcset') || '').trim();
    const current = String(img.getAttribute('src') || '').trim();
    const isBroken = !current || current.indexOf('data:image') === 0;
    if (dataSrc && isBroken) img.setAttribute('src', dataSrc);
    if (dataSrcset && !img.getAttribute('srcset')) img.setAttribute('srcset', dataSrcset);

    // Hand the image to lazySizes ONLY if it is genuinely a deferred image:
    // it must still be carrying a data-src/data-srcset and must not have
    // loaded yet.
    //
    // unveil() is not a no-op on an already-loaded <img>. With no data-src to
    // apply it strips the src attribute outright and stamps .lazyloaded, which
    // blanks the picture:
    //   before  naturalWidth=360  src="...width=360"  class="product-img"
    //   after   naturalWidth=0    src=(absent)        class="product-img lazyloaded"
    // Since setActiveIndex() calls revealImage() on every slide change, that
    // destroyed each slide the moment it became visible — the 2nd and 3rd
    // images went blank as soon as you tapped a dot or swiped.
    //
    // Product cards render a real src straight from Liquid and carry no
    // data-src, so for them this correctly does nothing at all.
    const stillDeferred = !!(img.getAttribute('data-src') || img.getAttribute('data-srcset'));
    const notLoadedYet = !img.naturalWidth;
    if (
      stillDeferred &&
      notLoadedYet &&
      window.lazySizes &&
      window.lazySizes.loader &&
      typeof window.lazySizes.loader.unveil === 'function'
    ) {
      try { window.lazySizes.loader.unveil(img); } catch (e) {}
    }
  }

  function setActiveIndex(slider, index) {
    const slides = getSlides(slider);
    if (!slides.length) return;
    const maxIndex = slides.length - 1;
    const next = Math.max(0, Math.min(maxIndex, toNum(index, 0)));
    revealImage(slides[next]);

    if (isNewCardSlider(slider)) {
      slides.forEach(function (slide, idx) {
        slide.classList.toggle('active', idx === next);
      });
      getDots(slider).forEach(function (dot, idx) {
        dot.classList.toggle('active', idx === next);
      });
    } else {
      slides.forEach(function (slide, idx) {
        const active = idx === next;
        slide.classList.toggle('product-block__image--active', active);
        slide.classList.toggle('product-block__image--inactivated', !active);
        slide.classList.remove('product-block__image--show-on-hover');
      });
      getDots(slider).forEach(function (dot, idx) {
        dot.classList.toggle('product-block__image-dot--active', idx === next);
      });
    }

    slider.setAttribute('data-active-slide-index', String(next));
  }

  function findSliderFromTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('.card-image-wrap, .product-block-card .image-cont, [data-product-card-slider]');
  }

  function ensureSlider(slider) {
    if (!slider || slider.getAttribute('data-k-slider-init') === '1') return;
    const slides = getSlides(slider);
    if (!slides.length) return;
    slider.setAttribute('data-k-slider-init', '1');
    const isDisabledByData = slider.getAttribute('data-card-slider-disabled') === 'true';
    const isInsideCarouselContext = !!(slider.closest && slider.closest(CAROUSEL_CONTEXT_SELECTOR));
    const disableTouchSwipe = isDisabledByData || isInsideCarouselContext;
    swipeState.set(slider, {
      startX: 0,
      startY: 0,
      tracking: false,
      didSwipe: false,
      disableTouchSwipe: disableTouchSwipe,
    });

    const newCardSlider = isNewCardSlider(slider);
    const stampedIndex = slider.getAttribute('data-active-slide-index');
    // A filter can stamp the selected variant image before slider initialization.
    // Preserve that image; otherwise new cards intentionally open on image 2.
    let activeFromDom = newCardSlider
      ? (stampedIndex !== null && stampedIndex !== '' ? Number(stampedIndex) : 1)
      : 0;
    if (!newCardSlider) {
      slides.forEach(function (slide, idx) {
        if (slide.classList.contains('active') || slide.classList.contains('product-block__image--active')) {
          activeFromDom = idx;
        }
      });
    }
    setActiveIndex(slider, activeFromDom);
  }

  function bindDelegatedHandlers() {
    if (delegatedBound) return;
    delegatedBound = true;

    document.addEventListener('click', function (event) {
      const newDot = event.target && event.target.closest
        ? event.target.closest('.card-carousel-dots .dot[data-slide], .card-carousel-dots span.dot')
        : null;
      if (newDot) {
        const slider = newDot.closest('.card-image-wrap, .image-cont');
        if (!slider) return;
        ensureSlider(slider);
        event.preventDefault();
        event.stopPropagation();
        const idx = toNum(newDot.getAttribute('data-slide'), Array.prototype.indexOf.call(
          slider.querySelectorAll('.card-carousel-dots .dot, .card-carousel-dots span.dot'),
          newDot
        ));
        setActiveIndex(slider, idx);
        return;
      }

      const legacyDot = event.target && event.target.closest
        ? event.target.closest('.product-block__image-dot[data-slide-dot-index]')
        : null;
      if (legacyDot) {
        const slider = legacyDot.closest('[data-product-card-slider]');
        if (!slider) return;
        ensureSlider(slider);
        event.preventDefault();
        const idx = toNum(legacyDot.getAttribute('data-slide-dot-index'), 0);
        setActiveIndex(slider, idx);
        return;
      }

      const slider = findSliderFromTarget(event.target);
      if (!slider) return;
      const state = swipeState.get(slider);
      if (!state || !state.didSwipe) return;
      event.preventDefault();
      event.stopPropagation();
      state.didSwipe = false;
    }, true);

    function onPointerStart(clientX, clientY, slider) {
      ensureSlider(slider);
      const state = swipeState.get(slider);
      if (!state || state.disableTouchSwipe) return;
      state.startX = clientX;
      state.startY = clientY;
      state.tracking = true;
      state.didSwipe = false;
    }

    function onPointerEnd(clientX, clientY, slider) {
      const state = swipeState.get(slider);
      if (!state || state.disableTouchSwipe || !state.tracking) return;
      state.tracking = false;
      const dx = clientX - state.startX;
      const dy = clientY - state.startY;
      if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;

      state.didSwipe = true;
      const current = toNum(slider.getAttribute('data-active-slide-index'), 0);
      const count = getSlides(slider).length;
      if (count < 2) return;
      const next = dx < 0
        ? (current >= count - 1 ? 0 : current + 1)
        : (current <= 0 ? count - 1 : current - 1);
      setActiveIndex(slider, next);
      window.setTimeout(function () {
        state.didSwipe = false;
      }, 260);
    }

    document.addEventListener('touchstart', function (event) {
      const slider = findSliderFromTarget(event.target);
      if (!slider) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      onPointerStart(touch.clientX, touch.clientY, slider);
    }, { passive: true });

    document.addEventListener('touchcancel', function (event) {
      const slider = findSliderFromTarget(event.target);
      if (!slider) return;
      const state = swipeState.get(slider);
      if (!state) return;
      state.tracking = false;
    }, { passive: true });

    document.addEventListener('touchend', function (event) {
      const slider = findSliderFromTarget(event.target);
      if (!slider) return;
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      onPointerEnd(touch.clientX, touch.clientY, slider);
    }, { passive: true });

    // Desktop mouse drag swipe
    document.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      if (event.target && event.target.closest && event.target.closest('.card-carousel-dots, .card-wishlist-icon, .ct_wishlist_custom')) return;
      const slider = findSliderFromTarget(event.target);
      if (!slider || !isNewCardSlider(slider)) return;
      activeMouseSlider = slider;
      onPointerStart(event.clientX, event.clientY, slider);
    });

    document.addEventListener('mouseup', function (event) {
      if (!activeMouseSlider) return;
      const slider = activeMouseSlider;
      activeMouseSlider = null;
      onPointerEnd(event.clientX, event.clientY, slider);
    });
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-product-card-slider]').forEach(ensureSlider);
    scope.querySelectorAll('.product-block-card .card-image-wrap, .product-block-card .image-cont, .wizzy-result-product .card-image-wrap').forEach(ensureSlider);
    bindDelegatedHandlers();
  }

  window.KProductCardSlider = window.KProductCardSlider || { init };
  // Always re-bind init so theme reloads pick up new card markup support
  window.KProductCardSlider.init = init;
  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });
})();

// OOS script
let isSimilarProductLoading = false;
const similarPopupPageClasses = ['global', 'cart', 'wishlist', 'product', 'pdp'];

function getSimilarPopup() {
  return document.querySelector('.similar_pro_popup.oos-global-popup');
}

function getSimilarSku($trigger) {
  return (
    $trigger.attr("cart_data-product-id") ||
    $trigger.attr("data-sku") ||
    $trigger.attr("data-product-sku") ||
    $trigger.closest("[data-sku]").attr("data-sku") ||
    ""
  ).toString().trim();
}

// PDP module analytics (events sheet). Helper lives in assets/clevertap_custom.js.liquid
// (deferred after this file) — queue until it exists.
function kSimilarTrack(name, props) {
  if (typeof window.kPdpTrack === 'function') window.kPdpTrack(name, props);
  else (window.__kPdpTrackQueue = window.__kPdpTrackQueue || []).push([name, props]);
}

$(document).on("click", ".get-similar-products", function () {
  showLoader();
  if (isSimilarProductLoading) {
    closeLoader();
    return;
  }
  isSimilarProductLoading = true;
  setTimeout(() => isSimilarProductLoading = false, 1000); // Avoid duplicate calls

  const $trigger = $(this);
  const productText = $trigger.data("productname") || "Product";
  const currPageRaw = ($trigger.data('pagetype') || 'global').toString().toLowerCase();
  const currPage = currPageRaw.replace(/[^a-z0-9_-]/g, '') || 'global';
  const popupElement = getSimilarPopup();
  if (!popupElement) {
    closeLoader();
    console.warn("Similar products popup container not found.");
    return;
  }
  const $popup = $(popupElement);
  $popup.removeClass(similarPopupPageClasses.join(' ')).addClass(currPage);
  const $popupInner = $popup.find(".similar_pro_popup_inner");
  const $popupVar = $popup.find(".similar_pro_popup_var");
  const $popupBody = $popup.find(".similar_pro_popup_body");

  clevertap.event.push("Clicked OOS_Similar Products", {
    pageType: currPage,
    productTitle: productText,
  });
  kSimilarTrack('view_similar_cta_clicked', {
    trigger_page: currPage,
    trigger_product_name: productText,
    trigger_sku: getSimilarSku($trigger)
  });

  $popup.find('.similar_pro_popup_left p').text(productText);

  $popupVar.empty();
  $popupBody.empty();
  $popupInner.removeClass("Varient_active Product_active");

  const sku = getSimilarSku($trigger);
  if (!sku) {
    closeLoader();
    $popup.addClass("similar_pro_pop_active");
    $popupInner.addClass("active");
    window.themeScrollLock && window.themeScrollLock.lock();
    console.warn("Missing SKU for similar products trigger:", this);
    return;
  }

  $.ajax({
    url: `${window.apiUrl}/callback/similar-products-with-variants`,
    data: { sku },
    type: "GET",
    headers: { "Content-Type": "application/json" },
  })
    .done(function (response) {
      if (response.item?.variants?.length) {
        response.item.variants.forEach(function (variant) {
          let percentage = ((variant.price - variant.sellingPrice) / variant.price) * 100;
          percentage = Math.round(percentage);
          const variantIdHtml = `
            <div class="similar_pro_box">
              <div class="similar_pro_box_img" data-productname="${variant.name}" data-pageType="${currPage}">
                <a href="https://www.kushals.com/products/${variant.handle}?variant=${variant.id}">
                  <img src="${variant.image}&width=250" alt="${variant.name}" width="400" height="400">
                </a>
              </div>
              <div class="similar_pro_box_content">
                <h3>${variant.name}</h3>
                <div class="ct_collection_product_box_item_price">
                  <span class="discount_price">₹${variant.sellingPrice}</span>
                  ${percentage > 0 
                    ? `<span class="original_price">₹${variant.price}</span>
                      <span class="discount_percentage">${percentage}% OFF</span>` 
                    : ''
                  }
                </div>
              </div>
            </div>`;
          $popupVar.append(variantIdHtml);
          $popupInner.addClass("Varient_active");
        });
      }

      if (response.product?.length) {
        response.product.forEach(function (product) {
          let percentage = ((product.price - product.sellingPrice) / product.price) * 100;
          percentage = Math.round(percentage);
          const productHtml = `
            <div class="similar_pro_box">
              <div class="similar_pro_box_img" data-productname="${product.name}" data-pageType="${currPage}">
                <a href="https://www.kushals.com/products/${product.handle}?variant=${product.id}">
                  <img src="${product.image}&width=250" alt="${product.name}" width="400" height="400">
                </a>
              </div>
              <div class="similar_pro_box_content">
                <h3>${product.name}</h3>
                <div class="ct_collection_product_box_item_price">
                  <span class="discount_price">₹${product.sellingPrice}</span>
                  ${percentage > 0 
                    ? `<span class="original_price">₹${product.price}</span>
                      <span class="discount_percentage">${percentage}% OFF</span>` 
                    : ''
                  }
                </div>

              </div>
            </div>`;
          $popupBody.append(productHtml);
          $popupInner.addClass("Product_active");
        });
      }
      $popup.addClass("similar_pro_pop_active");
      $popupInner.addClass("active");
      window.themeScrollLock && window.themeScrollLock.lock();
      if (response.item?.variants?.length != 0 || response.product?.length != 0 ) {
        clevertap.event.push("Closematch OOS API Called", {
          pageType: currPage,
          productTitle: productText,
        });
      }
      kSimilarTrack('view_similar_module_viewed', {
        trigger_page: currPage,
        trigger_product_name: productText,
        trigger_sku: sku,
        variant_count: (response.item && response.item.variants && response.item.variants.length) || 0,
        product_count: (response.product && response.product.length) || 0
      });
      closeLoader();
    })
    .fail(function (error) {
      closeLoader();
      $popup.addClass("similar_pro_pop_active");
      $popupInner.addClass("active");
      window.themeScrollLock && window.themeScrollLock.lock();
      console.error("Error fetching similar products:", error);
      kSimilarTrack('view_similar_api_failed', {
        trigger_page: currPage,
        trigger_product_name: productText,
        trigger_sku: sku,
        http_status: error && error.status != null ? error.status : '',
        error_message: (error && (error.statusText || error.message)) || ''
      });
    });
});

// Close popup on cross or background click
$(document).on('click', '.similar_pro_popup', function (e) {
  if (!$(e.target).closest('.similar_pro_popup_inner').length) {
   oosCloseModal()
  }
});

function oosCloseModal () {
  $(".similar_pro_popup").removeClass("similar_pro_pop_active");
  $(".similar_pro_popup_inner").removeClass("active");
  window.themeScrollLock && window.themeScrollLock.unlock();
}




document.addEventListener('DOMContentLoaded', () => {
  const oosProducts = document.querySelectorAll('.similar_pro_box_img');

  oosProducts.forEach((productEl) => {
    productEl.addEventListener('click', (e) => {
      const target = e.currentTarget;
      const productName = target.getAttribute('data-productname');
      const pageType = target.getAttribute('data-pagetype');

      clevertap.event.push("OOS_Recommendation Clicked", {
        pageType: pageType,
        productTitle: productName,
      });
    });
  });

  const referrer = document.referrer;
  if (referrer.includes('find-your-perfect-sparkle') && window.page === 'collection') {
    // Hide only the duplicate <h1>. `.ct_header_title` also wraps the product
    // count and the nearby-stores toggle (.coll-title-meta-row), so hiding the
    // whole block takes both down with it.
    const finderPlpTitle = document.querySelector('.ct_header_title-main');
    if (finderPlpTitle) finderPlpTitle.style.display = 'none';
  }

  // PLP reached from the Jewellery Finder or the Gift Finder. Both wizards write
  // this key on their hand-off (assets/jewellery-find.js, assets/gift-for-her-find.js)
  // with the `feature` and the three Selected_Tile_Q{n} params. Fire once, then
  // clear it, so a refresh of the PLP does not report a second visit.
  if (window.page === 'collection') {
    try {
      const raw = sessionStorage.getItem('finder_visited_plp_params');
      if (raw) {
        sessionStorage.removeItem('finder_visited_plp_params');
        const finderParams = JSON.parse(raw);
        if (typeof clevertap !== 'undefined' && clevertap?.event?.push) {
          clevertap.event.push("visited_plp_from_gift_finder", {
            feature: finderParams.feature || "",
            Selected_Tile_Q1: finderParams.Selected_Tile_Q1 || "",
            Selected_Tile_Q2: finderParams.Selected_Tile_Q2 || "",
            Selected_Tile_Q3: finderParams.Selected_Tile_Q3 || "",
            screen_url: window.location.href
          });
        }
      }
    } catch (e) {}
  }

    // Lazy video playback
    const collectVideos = () => Array.from(document.querySelectorAll('video'));
    const isAppWebview = Boolean(window.webview);
    const isIos = /iPad|iPhone|iPod/.test(window.navigator.userAgent || '');

    if (isAppWebview) {
      const handledAttr = 'data-kushals-video-init';

      const prepareVideoAttrs = (video, { useBooleanAttr = false } = {}) => {
        const boolValue = useBooleanAttr ? 'true' : '';
        video.setAttribute('playsinline', boolValue);
        video.setAttribute('webkit-playsinline', boolValue);
        video.setAttribute('muted', boolValue);
        video.playsInline = true;
        video.muted = true;
      };

      const ensureIosPlayback = (video) => {
        if (!video || video.getAttribute(handledAttr) === 'ios') { return; }
        video.setAttribute(handledAttr, 'ios');

        const maxRetries = 5;

        const prepareVideo = () => {
          prepareVideoAttrs(video, { useBooleanAttr: true });
        };

        const attemptPlay = (retries, resetProgress) => {
          if (resetProgress) {
            try { video.currentTime = 0; } catch (err) {}
          }

          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              if (retries <= 0) { return; }
              setTimeout(() => attemptPlay(retries - 1, false), 300);
            });
          }
        };

        const kickOff = (resetProgress = false) => {
          prepareVideo();
          attemptPlay(maxRetries, resetProgress);
        };

        if (video.readyState >= 2) {
          kickOff(false);
        } else {
          video.addEventListener('loadeddata', () => kickOff(false), { once: true });
        }

        video.addEventListener('pause', () => kickOff(false));
        video.addEventListener('ended', () => kickOff(true));
      };

      const ensureAndroidPlayback = (video) => {
        if (!video || video.getAttribute(handledAttr) === 'android') { return; }
        video.setAttribute(handledAttr, 'android');

        const MAX_RETRIES = 5;

        const prepareVideo = () => {
          prepareVideoAttrs(video);
          video.setAttribute('autoplay', '');
          video.autoplay = true;
        };

        const attemptPlay = (retries) => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              if (retries <= 0) { return; }
              setTimeout(() => kickOff({ retries: retries - 1 }), 400);
            });
          }
        };

        const kickOff = ({ resetProgress = false, retries = MAX_RETRIES } = {}) => {
          prepareVideo();

          if (resetProgress) {
            try { video.currentTime = 0; } catch (err) {}
          }

          if (video.readyState >= 2) {
            attemptPlay(retries);
          } else {
            const onReady = () => {
              video.removeEventListener('loadeddata', onReady);
              video.removeEventListener('canplay', onReady);
              attemptPlay(retries);
            };

            video.addEventListener('loadeddata', onReady);
            video.addEventListener('canplay', onReady);
            if (video.readyState === 0 && typeof video.load === 'function') {
              video.load();
            }
          }
        };

        kickOff();

        video.addEventListener('stalled', () => kickOff());
        video.addEventListener('error', () => kickOff({ resetProgress: true }));
        video.addEventListener('ended', () => {
          if (!video.loop) {
            kickOff({ resetProgress: true });
          }
        });
      };

      const ensurePlayback = (video) => {
        if (isIos) {
          ensureIosPlayback(video);
        } else {
          ensureAndroidPlayback(video);
        }
      };

      const bootstrapVideos = () => {
        collectVideos().forEach(ensurePlayback);
      };

      bootstrapVideos();

      if (typeof MutationObserver !== 'undefined') {
        const mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach(({ addedNodes }) => {
            addedNodes.forEach((node) => {
              if (node.nodeName === 'VIDEO') {
                ensurePlayback(node);
              } else if (node.querySelectorAll) {
                node.querySelectorAll('video').forEach(ensurePlayback);
              }
            });
          });
        });

        mutationObserver.observe(document.body, { childList: true, subtree: true });
      } else {
        const fallbackScan = setInterval(bootstrapVideos, 1500);
        window.addEventListener('beforeunload', () => clearInterval(fallbackScan));
      }
    } else {
      const videosObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const vid = entry.target;
          if (entry.isIntersecting) {
            vid.play().catch(()=>{});
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.5 });

      collectVideos().forEach(v => videosObserver.observe(v));
    }
});


// Close popup if cart overlay is clicked
$(document).on('click', '.mm-ajaxcart-overlay.has--active', function () {
  $(".similar_pro_popup").click();
});

/* Sale Timer – global controller */
(function () {
  // public API (optional)
  window.SaleTimer = window.SaleTimer || {};

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function parseCountdown(target) {
    var ts = new Date(target).getTime();
    if (isNaN(ts)) {
      try { ts = Date.parse(target); } catch (e) {}
    }
    return isNaN(ts) ? null : ts;
  }

  function mappingForContext(ctx) {
    if (ctx === 'cart') {
      return { days: '.js-cart-timer-days', hours: '.js-cart-timer-hours', mins: '.js-cart-timer-minutes', secs: '.js-cart-timer-seconds' };
    }
    if (ctx === 'pdp') {
      return { days: '.ct_js-timer-days', hours: '.ct_js-timer-hours', mins: '.ct_js-timer-minutes', secs: '.ct_js-timer-seconds' };
    }
    // default 'section'
    return { days: '.js-timer-days', hours: '.js-timer-hours', mins: '.js-timer-minutes', secs: '.js-timer-seconds' };
  }

  function destroyTimer(el) {
    if (!el) return;
    var id = el.dataset.timerIntervalId;
    if (id) {
      clearInterval(Number(id));
      delete el.dataset.timerIntervalId;
    }
    delete el.dataset.timerInitialized;
  }

  function initTimer(el) {
    if (!el || el.dataset.timerInitialized === '1') return;

    var target = el.getAttribute('data-countdown');
    if (!target) return;

    var ts = parseCountdown(target);
    if (ts == null) return;

    var ctx = el.getAttribute('data-context') || 'section';
    var sel = mappingForContext(ctx);

    var daysEl  = el.querySelector(sel.days);
    var hoursEl = el.querySelector(sel.hours);
    var minsEl  = el.querySelector(sel.mins);
    var secsEl  = el.querySelector(sel.secs);
    if (!(daysEl && hoursEl && minsEl && secsEl)) return;

    // wrapper div for the days unit so we can hide it entirely
    var daysBlock = daysEl.closest('.end-timer-block') || daysEl.closest('.timer-block');
    var forceShowDays = el.classList.contains('pre-sale-end-time');

    // optional click-through for the generic "section" context
    if (ctx === 'section') {
      var link = el.getAttribute('data-link');
      if (link && !el.dataset.timerClickBound) {
        el.addEventListener('click', function () { window.location.href = link; });
        el.dataset.timerClickBound = '1';
      }
    }

    var second = 1000, minute = second * 60, hour = minute * 60, day = hour * 24;

    function render() {
      var now = Date.now();
      var distance = ts - now;

      if (distance <= 0) {
        // expired
        daysEl.textContent  = '00';
        hoursEl.textContent = '00';
        minsEl.textContent  = '00';
        secsEl.textContent  = '00';
        if (daysBlock) daysBlock.style.display = forceShowDays ? '' : 'none';
        return false; // stop interval
      }

      var rd = Math.floor(distance / day);
      var rh = Math.floor((distance % day) / hour);
      var rm = Math.floor((distance % hour) / minute);
      var rs = Math.floor((distance % minute) / second);

      if (daysBlock) {
        // Keep pre-sale layout stable by always showing day block there.
        // Default behavior elsewhere: hide day block when value is 0.
        daysBlock.style.display = forceShowDays ? '' : (rd <= 0 ? 'none' : '');
      }

      daysEl.textContent  = pad2(rd);
      hoursEl.textContent = pad2(rh);
      minsEl.textContent  = pad2(rm);
      secsEl.textContent  = pad2(rs);
      return true;
    }

    // first paint
    render();

    var interval = setInterval(function () {
      if (!document.body.contains(el)) {
        // element removed – stop and cleanup
        clearInterval(interval);
        return;
      }
      if (!render()) {
        clearInterval(interval);
      }
    }, 1000);

    el.dataset.timerInitialized = '1';
    el.dataset.timerIntervalId = String(interval);
  }

  function initWithin(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.end-time[data-countdown]');
    nodes.forEach(initTimer);
  }

  // expose manual hooks in case your theme has custom drawer events
  window.SaleTimer.initAll = function () { initWithin(document); };
  window.SaleTimer.initWithin = initWithin;

  // run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
  } else {
    initWithin(document);
  }

  // auto-init for dynamically injected content (cart drawer, quickview, etc.)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      // added nodes
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return; // element only
        if (n.matches && n.matches('.end-time[data-countdown]')) initTimer(n);
        if (n.querySelectorAll) {
          n.querySelectorAll('.end-time[data-countdown]').forEach(initTimer);
        }
      });
      // removed nodes => clear intervals
      m.removedNodes && m.removedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.end-time[data-countdown]')) destroyTimer(n);
        if (n.querySelectorAll) {
          n.querySelectorAll('.end-time[data-countdown]').forEach(destroyTimer);
        }
      });
    });
  });
  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });

  // optional: listen to common theme events (harmless if they never fire)
  document.addEventListener('shopify:section:load', function (e) { initWithin(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { initWithin(e.target); });
  document.addEventListener('cart:refresh', function () { initWithin(document); });
  document.addEventListener('cart:updated', function () { initWithin(document); });
  document.addEventListener('drawer:open', function (e) { initWithin(e.target || document); });
})();


window.addEventListener("load", function() {
  // Handle Download button click
  const ctaBtn = document.querySelector("[data-role='cta']");
  if (ctaBtn) {
    ctaBtn.addEventListener("click", function () {
      clevertap.event.push("clicked_flyer_appdownload_button");
    });
  }

  // Handle Close icon click
  const closeBtn = document.querySelector("[data-af-close-button='true']");
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      clevertap.event.push("clicked_flyer_appdownload_button_closed");
    });
  }
});

// OTP modal triggers after a 5 second delay on eligible pages + rich logging to sessionStorage.
// Runs only for non-logged-in users. Each scenario fires once per user.
document.addEventListener("DOMContentLoaded", function () {
  const KEY_COUNT = "ct_pv_count";
  const KEY_REDIRECT = "otpRedirect";
  const LOG_KEY = "ct_otp_logs";
  const GLOBAL_OTP_LOCK_UNTIL_KEY = "ct_otp_global_lock_until";
  const GLOBAL_OTP_LOCK_MS = 2 * 60 * 60 * 1000;

  const DONE_PRODUCT_4 = "ct_otp_done_product4";
  const DONE_INDEX_20PCT = "ct_otp_done_index_20pct";
  const DONE_PLP_20PCT = "ct_otp_done_plp_20pct";

  const NOTICE_PRODUCT_4 = "ct_otp_notice_product4";
  const NOTICE_INDEX_20PCT = "ct_otp_notice_index_20pct";
  const NOTICE_PLP_20PCT = "ct_otp_notice_plp_20pct";

  const FROM_PDP = "PDP";
  const FROM_HOME = "Home Page";
  const FROM_PLP = "PLP";

  // Automatic OTP popup controls.
  // Set any flag to false to temporarily disable that automatic flow.
  // Set it back to true whenever the flow should be enabled again.
  const ENABLE_PDP_4TH_VIEW_OTP = false;
  const ENABLE_HOME_5_SECOND_OTP = false;
  const ENABLE_PLP_5_SECOND_OTP = false;

  function isLoggedInCustomer() {
    return String(document.body?.dataset?.customer || "").toLowerCase() === "true";
  }
  function isProductPage() {
    return window.page === "product" || document.body.classList.contains("template-product");
  }
  function isIndexPage() {
    return window.page === "index" || document.body.classList.contains("template-index");
  }
  function isCollectionPage() {
    return window.page === "collection" || document.body.classList.contains("template-collection");
  }
  function shouldSkipHomeAutoPopup() {
    const path = window.location.pathname || "";

    if (isCollectionPage()) return true;
    if (path === "/pages/account-edit") return true;
    if (path === "/account" || path.startsWith("/account/")) return true;
    if (path.includes("/pages/store-details/")) return true;

    return false;
  }
  function normalizeHomeAutoPopupKey(path) {
    const raw = String(path || "").toLowerCase().replace(/^\/+|\/+$/g, "");
    const safe = raw.replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    return safe || "root";
  }
  function getHomeAutoPopupKeys() {
    const scope = normalizeHomeAutoPopupKey(window.location.pathname || "/");
    return {
      doneKey: `ct_otp_done_home_auto_${scope}`,
      noticeKey: `ct_otp_notice_home_auto_${scope}`
    };
  }

  function readLogs() {
    try { return JSON.parse(sessionStorage.getItem(LOG_KEY) || "[]"); } catch { return []; }
  }
  function writeLogs(arr) {
    try {
      sessionStorage.setItem(LOG_KEY, JSON.stringify(arr.slice(-200)));
    } catch {}
  }
  function addLog(message, extra = {}) {
    const entry = {
      ts: new Date().toISOString(),
      url: window.location.href,
      ref: document.referrer || "direct",
      msg: message,
      ...extra
    };
    const logs = readLogs();
    logs.push(entry);
    writeLogs(logs);
  }
  function alreadyCameNotice(doneKey, noticeKey, label) {
    if (sessionStorage.getItem(doneKey) === "1" && sessionStorage.getItem(noticeKey) !== "1") {
      const msg = `OTP already came for ${label}; it won't show again for this scenario.`;
      addLog(msg, { doneKey: doneKey });
      sessionStorage.setItem(noticeKey, "1");
    }
  }

  function getGlobalOtpLockUntil() {
    const raw = localStorage.getItem(GLOBAL_OTP_LOCK_UNTIL_KEY) || sessionStorage.getItem(GLOBAL_OTP_LOCK_UNTIL_KEY);
    const ts = Number(raw);
    return Number.isFinite(ts) ? ts : 0;
  }
  function isGlobalOtpLocked() {
    return Date.now() < getGlobalOtpLockUntil();
  }
  function setGlobalOtpLock(openFrom, reason) {
    const lockUntil = Date.now() + GLOBAL_OTP_LOCK_MS;
    localStorage.setItem(GLOBAL_OTP_LOCK_UNTIL_KEY, String(lockUntil));
    sessionStorage.setItem(GLOBAL_OTP_LOCK_UNTIL_KEY, String(lockUntil));
    addLog("Global OTP lock set", {
      OpenFrom: openFrom,
      Reason: reason,
      lockUntilISO: new Date(lockUntil).toISOString()
    });
  }
  function addGlobalLockNotice(openFrom) {
    const lockUntil = getGlobalOtpLockUntil();
    addLog("OTP blocked by 24h global lock", {
      OpenFrom: openFrom,
      lockUntilISO: lockUntil ? new Date(lockUntil).toISOString() : null
    });
  }

  function pushCT(openFrom) {
    try {
      if (window.clevertap?.event?.push) {
        window.clevertap.event.push("Login_Popup_Opened", {
          Scenario: document.referrer || "direct",
          PageType: window.page || null,
          PageURL: window.location.href,
          Referrer: document.referrer || null
        });
        addLog("Clevertap event pushed", { event: "otp_login_initiated", OpenFrom: openFrom });
      }
    } catch (e) {
      addLog("Clevertap push failed", { error: String(e) });
    }
  }

  function openOtp(openFrom) {
    try {
      switch (openFrom) {
        case FROM_PDP:
          if (typeof window.openOtpFromProductViews === "function") return window.openOtpFromProductViews();
          break;
        case FROM_HOME:
          if (typeof window.openOtpFromScrollHome === "function") return window.openOtpFromScrollHome();
          break;
        case FROM_PLP:
          if (typeof window.openOtpFromScrollPLP === "function") return window.openOtpFromScrollPLP();
          break;
      }
      if (typeof window.showOtpModal === "function") return window.showOtpModal(false);
    } catch (e) {
      addLog("OTP open failed, fallback to showOtpModal", { error: String(e) });
      if (typeof window.showOtpModal === "function") window.showOtpModal(false);
    }
  }

  function triggerOTP_Once(doneKey, noticeKey, openFrom, reason) {
    if (isGlobalOtpLocked()) {
      addGlobalLockNotice(openFrom);
      return;
    }

    if (sessionStorage.getItem(doneKey) === "1") {
      alreadyCameNotice(doneKey, noticeKey, openFrom);
      return;
    }
    const redirectUrl = window.location.pathname + window.location.search;

    try {
      if (!sessionStorage.getItem(KEY_REDIRECT)) {
        sessionStorage.setItem(KEY_REDIRECT, redirectUrl);
      }
    } catch (_) {}

    pushCT(openFrom);
    addLog("OTP modal shown (once)", { OpenFrom: openFrom, Reason: reason });
    openOtp(openFrom);
    sessionStorage.setItem(doneKey, "1");
    setGlobalOtpLock(openFrom, reason);
  }

  function triggerOTP_Repeat(openFrom, reason) {
    if (isGlobalOtpLocked()) {
      addGlobalLockNotice(openFrom);
      return;
    }

    const redirectUrl = window.location.pathname + window.location.search;
    try {
      if (!sessionStorage.getItem(KEY_REDIRECT)) {
        sessionStorage.setItem(KEY_REDIRECT, redirectUrl);
      }
    } catch (_) {}

    pushCT(openFrom);
    addLog("OTP modal shown (repeat allowed)", { OpenFrom: openFrom, Reason: reason });
    openOtp(openFrom);
    setGlobalOtpLock(openFrom, reason);
  }

  function initProductViewOTP() {
    if (!ENABLE_PDP_4TH_VIEW_OTP) return;
    if (isLoggedInCustomer()) return;
    if (!isProductPage()) {
      alreadyCameNotice(DONE_PRODUCT_4, NOTICE_PRODUCT_4, FROM_PDP);
      return;
    }
    if (sessionStorage.getItem(DONE_PRODUCT_4) === "1") {
      alreadyCameNotice(DONE_PRODUCT_4, NOTICE_PRODUCT_4, FROM_PDP);
      return;
    }

    const currentCount = (parseInt(sessionStorage.getItem(KEY_COUNT) || "0", 10) || 0) + 1;
    sessionStorage.setItem(KEY_COUNT, String(currentCount));

    // Use >= 4 so a global lock on exactly the 4th view does not permanently skip PDP OTP.
    if (currentCount >= 4) {
      triggerOTP_Once(DONE_PRODUCT_4, NOTICE_PRODUCT_4, FROM_PDP, "4th PDP view");
    }
  }

  function makeProgressWatcher(threshold, onThreshold) {
    const THRESH = Math.max(0, Math.min(1, threshold));

    function progress() {
      const doc = document.documentElement;
      const total = Math.max(doc.scrollHeight - window.innerHeight, 1);
      return window.scrollY / total;
    }
    function maybeFire(reason) {
      onThreshold(reason);
      window.removeEventListener("scroll", onScroll, passiveOpts);
      window.removeEventListener("resize", onScroll, passiveOpts);
    }
    function onScroll() {
      if (progress() >= THRESH) {
        maybeFire(`Scrolled to ${Math.round(THRESH * 100)}%`);
      }
    }
    const passiveOpts = { passive: true };

    if (progress() >= THRESH) {
      onThreshold(`Already >=${Math.round(THRESH * 100)}% on load`);
      return null;
    }

    window.addEventListener("scroll", onScroll, passiveOpts);
    window.addEventListener("resize", onScroll, passiveOpts);

    return () => {
      window.removeEventListener("scroll", onScroll, passiveOpts);
      window.removeEventListener("resize", onScroll, passiveOpts);
    };
  }

  function initHome20() {
    if (!ENABLE_HOME_5_SECOND_OTP) return;
    if (isLoggedInCustomer()) return;
    if (shouldSkipHomeAutoPopup()) {
      return;
    }
    const homeAutoKeys = getHomeAutoPopupKeys();
    if (sessionStorage.getItem(homeAutoKeys.doneKey) === "1") {
      alreadyCameNotice(homeAutoKeys.doneKey, homeAutoKeys.noticeKey, FROM_HOME);
      return;
    }

    setTimeout(() => {
      triggerOTP_Once(homeAutoKeys.doneKey, homeAutoKeys.noticeKey, FROM_HOME, "Home page after 5 seconds", false, false);
    }, 5000);
  }

  function initPLP20_Once() {
    if (!ENABLE_PLP_5_SECOND_OTP) return;
    if (isLoggedInCustomer()) return;

    // ✅ Updated to remove Jewellery Finder dependency
    if (!isCollectionPage()) {
      alreadyCameNotice(DONE_PLP_20PCT, NOTICE_PLP_20PCT, FROM_PLP);
      return;
    }

    if (sessionStorage.getItem(DONE_PLP_20PCT) === "1") {
      alreadyCameNotice(DONE_PLP_20PCT, NOTICE_PLP_20PCT, FROM_PLP);
      return;
    }

    setTimeout(() => {
      triggerOTP_Once(DONE_PLP_20PCT, NOTICE_PLP_20PCT, FROM_PLP, "PLP after 5 seconds");
    }, 5000);
  }



  if (!isLoggedInCustomer()) {
    initProductViewOTP();
    initHome20();
    initPLP20_Once();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const GLOBAL_OTP_LOCK_UNTIL_KEY = "ct_otp_global_lock_until";
  const GLOBAL_OTP_LOCK_MS = 24 * 60 * 60 * 1000;

  function getGlobalOtpLockUntil() {
    const raw = localStorage.getItem(GLOBAL_OTP_LOCK_UNTIL_KEY) || sessionStorage.getItem(GLOBAL_OTP_LOCK_UNTIL_KEY);
    const ts = Number(raw);
    return Number.isFinite(ts) ? ts : 0;
  }

  function isGlobalOtpLocked() {
    return Date.now() < getGlobalOtpLockUntil();
  }

  function setGlobalOtpLock() {
    const lockUntil = Date.now() + GLOBAL_OTP_LOCK_MS;
    localStorage.setItem(GLOBAL_OTP_LOCK_UNTIL_KEY, String(lockUntil));
    sessionStorage.setItem(GLOBAL_OTP_LOCK_UNTIL_KEY, String(lockUntil));
  }

  const isLoggedIn = (document.body.dataset.customer === "true");
  const isAccountEditPage = window.location.pathname === "/pages/account-edit";

  if (!isLoggedIn && isAccountEditPage) {
    landedOnAccountEditPage();
  }

  if (window.location.pathname.includes("/pages/store-details/")) {
    if (isLoggedIn) return;
    if (isGlobalOtpLocked()) return;
    if (!document.cookie.includes("storePageOtpShown=true")) {
      if (typeof openOtpFromStorePage === "function") {
        openOtpFromStorePage();
        setGlobalOtpLock();
      }
      document.cookie = "storePageOtpShown=true; path=/; max-age=" + (24 * 60 * 60);
    }
  }
});
function showOtpTermsGuest() {
    document.querySelector('.otp-terms-guest').style.display = 'block';
}


function renderPreEddCheckMessage(deliveryBy) {
  const eddPDP = document.querySelector(".clickpost-edd__heading");
  if (!eddPDP) return;

  const pinInputCheck = document.querySelector(".clickpost-edd__drop_pincode-input");
  if (pinInputCheck && pinInputCheck.value) return;

  const existingNotice = document.querySelector(".pre-edd-check");
  if (existingNotice) existingNotice.remove();

  const apiPinCheckContainer = document.createElement("div");
  apiPinCheckContainer.className = "pre-edd-check";

  const isInternationalShopper = 
    window.Shopify && window.Shopify.country && window.Shopify.country !== "IN";

  if (isInternationalShopper) {
    apiPinCheckContainer.className = "pre-edd-check international-user"
    const row2 = document.createElement("div");
    row2.className = "pre-edd-row";

    const img2 = document.createElement("span");
    img2.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.10744 0.878737C5.67009 0.316091 6.4332 0 7.2289 0H12.7724C13.5681 0 14.3312 0.316091 14.8939 0.878737L19.1225 5.10744C19.6852 5.67009 20.0013 6.4332 20.0013 7.2289V12.7724C20.0013 13.5681 19.6852 14.3312 19.1225 14.8939L14.8939 19.1225C14.3312 19.6852 13.5681 20.0013 12.7724 20.0013H7.2289C6.4332 20.0013 5.67009 19.6852 5.10744 19.1225L0.878737 14.8939C0.316091 14.3312 0 13.5681 0 12.7724V7.2289C0 6.4332 0.316091 5.67009 0.878737 5.10744L5.10744 0.878737ZM11.0007 6.00039C11.0007 5.44807 10.553 5.00033 10.0007 5.00033C9.44831 5.00033 9.00059 5.44807 9.00059 6.00039V11.0007C9.00059 11.5531 9.44831 12.0008 10.0007 12.0008C10.553 12.0008 11.0007 11.5531 11.0007 11.0007V6.00039ZM11.0007 13.9897C11.0007 13.4374 10.553 12.9896 10.0007 12.9896C9.44831 12.9896 9.00059 13.4374 9.00059 13.9897V14.0009C9.00059 14.5532 9.44831 15.001 10.0007 15.001C10.553 15.001 11.0007 14.5532 11.0007 14.0009V13.9897Z" fill="#454545"></path>
                        </svg>`

    const text2 = document.createElement("span");
    text2.innerHTML = "Deliveries outside India may incur extra duties and taxes upon delivery.";

    row2.append(img2, text2);
    apiPinCheckContainer.append(row2);
  } else if (deliveryBy) {
    const row1 = document.createElement("div");
    row1.className = "pre-edd-row";

    const img1 = document.createElement("img");
    img1.src =
      "//www.kushals.com/cdn/shop/files/Hurry_8b9a5a6f-ee84-4cf5-9751-19e5249d405e.png?v=17923254468046854946";
    img1.alt = "get-product";
    img1.width = 20;
    img1.loading = "lazy";

    const text1 = document.createElement("span");
    text1.innerHTML = `Order Now & Get it by <span class="edd-check-red">${deliveryBy}.</span>`;

    row1.append(img1, text1);
    apiPinCheckContainer.append(row1);
  } else {
    return;
  }

  eddPDP.appendChild(apiPinCheckContainer);
}

if (typeof window.handleStoreInput !== 'function') {
  window.handleStoreInput = function () {};
}

// Keep all free-shipping copy in sync with the web-settings API.
(function updateFreeShippingCopy() {
  if (!window.apiUrl) return;
  fetch(window.apiUrl + '/callback/web-settings')
    .then(function (response) { return response.json(); })
    .then(function (settings) {
      var value = Number(settings.freeShippingValue);
      if (!isFinite(value)) return;
      document.querySelectorAll('[data-free-shipping-value]').forEach(function (node) {
        node.textContent = value;
      });
    })
    .catch(function () {});
})();
